import { createStructuredSelector } from 'reselect';
import { loggedIn } from 'Selectors/DashboardSelector';

export const initialState = {
  content: '',
  datetime: '',
  version: '',
  loading: false,
  error: null,
};

export const ossAgreementReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case initialOSSAgreementRequest.type:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case initialOSSAgreementSuccess.type:
      return {
        ...state,
        ...payload,
        loading: false,
        error: null,
      };
    case initialOSSAgreementFailure.type:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};

const initialOSSAgreementRequest = () => ({ type: initialOSSAgreementRequest.type });
const initialOSSAgreementSuccess = (ossAgreement = {}) => ({ type: initialOSSAgreementSuccess.type, payload: ossAgreement });
const initialOSSAgreementFailure = (error = null) => ({ type: initialOSSAgreementFailure.type, payload: error });

const ossAgreementPrefix = 'oss-agreement/';
ossAgreementReducer.slice = 'ossAgreement';

initialOSSAgreementRequest.type = ossAgreementPrefix + 'initialOSSAgreementRequest';
initialOSSAgreementSuccess.type = ossAgreementPrefix + 'initialOSSAgreementSuccess';
initialOSSAgreementFailure.type = ossAgreementPrefix + 'initialOSSAgreementFailure';

export const OSSAgreementActions = {
  initialOSSAgreementRequest,
  initialOSSAgreementSuccess,
  initialOSSAgreementFailure,
};

export const getErrorTest = state => state.error;
export const getLoadingTest = state => state.loading;

export const getVersion = state => state[ossAgreementReducer.slice].version;
export const getContent = state => state[ossAgreementReducer.slice].content;
export const getDateTime = state => state[ossAgreementReducer.slice].datetime;
export const getError = state => state[ossAgreementReducer.slice].error;
export const getLoading = state => state[ossAgreementReducer.slice].loading;

export const getOSSAgreementInfoSelector = createStructuredSelector({
  version: getVersion,
  ossContent: getContent,
  dateVersion: getDateTime,
  error: getError,
  loading: getLoading,
  loggedIn,
});
